import React from 'react';
import '../App.css';

function ShowContainer({ project }) {
  const placeholderImage = '/assets/project-placeholder.svg';
  const imageSrc = project.image || placeholderImage;

  const handleImageError = (event) => {
    if (event.currentTarget.src.includes('project-placeholder.svg')) {
      return;
    }
    event.currentTarget.src = placeholderImage;
  };

  const projectLinks = Array.isArray(project.links) && project.links.length > 0
    ? project.links
    : [{ label: 'View Project', url: project.link }];

  return (
    <div className='cardContain'>
      <div className="img">
      <img src={imageSrc} onError={handleImageError} alt={project.name} />
      </div>
      <div className="info">
      <h2>{project.name}</h2>
      {project.type ? <p className="project-subtitle">{project.type}</p> : null}
      {project.outcome ? <p className="project-outcome">{project.outcome}</p> : null}
      <p>{project.description}</p>
      {Array.isArray(project.stack) && project.stack.length > 0 ? (
        <div className="project-stack">
          {project.stack.map((item) => (
            <span key={`${project.name}-${item}`}>{item}</span>
          ))}
        </div>
      ) : null}
      <div className="project-links">
        {projectLinks.map((item) => (
          <a key={`${project.name}-${item.label}`} href={item.url} target="_blank" rel="noopener noreferrer">
            {item.label}
          </a>
        ))}
      </div>
      </div>
    </div>
  );
}

export default ShowContainer;
